<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
    card="gestantes-puerperas"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '> 75 e <= 100' },
        { value: 'Bom', label: 'Bom', description: '> 50 e <= 75' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '> 25 e <= 50',
        },
        { value: 'Regular', label: 'Regular', description: '<= 25' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: null,
          codigo: null,
          desc: '1ª consulta presencial ou remota realizada por médica(o) ou enfermeira(o), até a 12ª semana de gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: '07 (sete) consultas presenciais ou remotas realizadas por médica(o) ou enfermeira(o) durante o período da gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: '07 (sete) registro de aferição de pressão arterial realizados durante o período da gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: '07 (sete) registros simultâneos de peso e altura durante o período da gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: '03 (três) visitas domiciliares realizadas por ACS/TACS, após a primeira consulta do pré-natal.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Vacina acelular contra difteria, tétano, coqueluche (dTpa) registrada a partir da 20ª semana de cada gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Registro dos testes rápidos ou dos exames avaliados para sífilis, HIV e hepatites B e C realizados no 1º trimestre de cada gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Registro dos testes rápidos ou dos exames avaliados para sífilis e HIV realizados no 3º trimestre de cada gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (um) registro de consulta presencial ou remota realizada por médica(o) ou enfermeira(o) durante o puerpério.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (uma) visita domiciliar realizada por ACS/TACS durante o puerpério.',
        },
        {
          icon: null,
          codigo: null,
          desc: '01 (uma) atividade em saúde bucal realizada por cirurgiã(ão) dentista ou técnica(o) de saúde bucal durante o período da gestação.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Lista de problemas ou condições ativos e resolvidos.',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: null,
          codigo: null,
          desc: 'Total de gestantes e puérperas vinculadas à equipe no período.',
        },
      ],
    }
  },
  methods: {
    /**
     * Abre o modal e aplica a fonte de dados inicial
     * @returns {void}
     */
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    /**
     * Fecha o modal base referenciado no componente
     * @returns {void}
     */
    close() {
      this.$refs.baseModal.close()
    },

    /**
     * Define a fonte de dados atual com base nos filtros selecionados e atualiza os valores manuais
     * @returns {void}
     */
    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    /**
     * Define manualmente o valor do numerador
     * @param {number} valor
     * @returns {void}
     */
    setNumerador(valor) {
      this.nManual = valor
    },

    /**
     * Define manualmente o valor do denominador
     * @param {number} valor
     * @returns {void}
     */
    setDenominador(valor) {
      this.dManual = valor
    },

    /**
     * Reseta os valores base do numerador e denominador com os valores atuais
     * @returns {void}
     */
    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    /**
     * Calcula o resultado com base no numerador e denominador informados
     * @param {{ numerador: number, denominador: number }} params
     * @returns {number}
     */
    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number((n / d).toFixed(2))
    },

    /**
     * Calcula a classe do resultado, retornando nível e variante visual
     * @param {{ resultado: number }} params
     * @returns {{ nivel: string, variant: string }}
     */
    calcularClasse({ resultado }) {
      if (resultado > 100) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 75 && resultado <= 100) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 50 && resultado <= 75) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado > 25 && resultado <= 50) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado <= 25) return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    /**
     * Aplica um preset de classificação ajustando numerador e denominador
     * @param {{
     *   tipo: string,
     *   setNumerador: (valor: number) => void,
     *   setDenominador: (valor: number) => void
     * }} params
     * @returns {void}
     */
    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(7501)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(5001)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(2501)
        setDenominador(100)
      } else {
        setNumerador(2500)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    /**
     * Formata o delta numérico para exibição com sinal
     * @param {number} val
     * @returns {string}
     */
    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    /**
     * Monta o texto de resultado para exibição
     * @param {{ resultado: number }} params
     * @returns {string}
     */
    montarTextoResultado({ resultado }) {
      return ``
    },
  },
}
</script>
